import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import moment from "moment";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import SearchFilterBox from "../../Components/SearchFilterBox";
import SingleDatePicker from "../../Components/SingleDatePicker";
import SummaryCards from "../../Components/TenantAttendance/SummaryCards";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import Table from "../../Components/TenantAttendance/Table";

const ViewTenantAttendance = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const [key, setKey] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("");
  const [masterData, setMasterData] = useState();
  const [apiData, setApiData] = useState();
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [summary, setSummary] = useState({
    totalLeads: 0,
    newLeads: 0,
    followUpLeads: 0,
    visitedLeads: 0,
    convertedLeads: 0,
  });
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );

  const query = `&s=${searchQuery}&t=${filterType}&filter=${filter}&date=${selectedDate}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/list/attendance/stats/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
      setSummary(res?.summary);
      setMasterData(res?.data);
      setIsFocused(true);
    }
  };

  const getError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  useEffect(() => {
    if (filterValue || selectedDate) {
      const handler = setTimeout(() => {
        getListMutate();
      }, 300);

      return () => clearTimeout(handler);
    }
  }, [filterValue, selectedDate]);

  useEffect(() => {
    if (filter) {
      const handler = setTimeout(() => {
        getListMutate();
      }, 200);

      return () => clearTimeout(handler);
    }
  }, [filter]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);

    return () => clearTimeout(handler);
  }, [property]);

  const submitHandler = (date) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    setSelectedDate(formattedDate);
    setFilterType("");
    setSearchQuery("");
  };

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);
    return () => clearTimeout(handler);
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);
    return () => clearTimeout(handler);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          View Attendance
          <Underline />
        </BoxTitle>
      </BoxHead>

      <FilterWrapper>
        <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
          <SearchFilterBox
            options={searchOptions}
            handleFilterChange={handleFilterChange}
            handleClearFilters={handleClearFilters}
          />
          <SingleDatePicker
            submitHandler={submitHandler}
            defaultLabel={moment(selectedDate).format("DD MMM YYYY")}
            initialDate={selectedDate}
          />
        </div>
      </FilterWrapper>
      {(isLoading || isRefetching) && !isFocused && (
        <SummarySkeletonLoading count={5} />
      )}
      {isFocused && apiData && <SummaryCards data={apiData} />}

      {!error && !isLoading && apiData && (
        <TableWrapper>
          <Table
            apiData={error ? [] : apiData?.length > 0 ? apiData : []}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
          />
          {(error || apiData?.length == 0) && !isLoading && <NotFoundModel />}
        </TableWrapper>
      )}
      {(isLoading || isRefetching) && <Loading />}
      {error && !isLoading && <NotFoundModel />}
    </BoxContainer>
  );
};

const FilterWrapper = tw.div`flex w-full pb-4 lg:flex-row flex-col lg:gap-0 gap-4`;
const TableWrapper = tw.h1`my-8 border  bg-white rounded-md `;
export default ViewTenantAttendance;
